import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpModule, XHRBackend, RequestOptions } from '@angular/http';
import { MaterialModule } from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule, Router } from '@angular/router';
import { routes } from './app.routes';
import { DatePickerModule } from 'ng2-datepicker';
import { DndModule } from 'ng2-dnd';
import { Ng2TweetModule } from 'ng2-tweet/lib/index';
import { MomentModule } from 'angular2-moment'

import {
  AppComponent, WelcomDialogComponent, HomeComponent, LoginComponent, SongsComponent, AlbumsComponent, ArtistsComponent, PlaylistsComponent,
  DashboardComponent, Four04Component, SignupComponent, LifestyleComponent, DemographicComponent, NotificationComponent, DeleteFromPlaylistComponent,
  BillingComponent, SignupStepsComponent, PasswordStrengthComponent, ForgotScreennameComponent, RequestPasswordResetComponent,
  UploadPictureDialog, EditScreenNameDialog, SongItemComponent, PlayButtonComponent, SongDurationComponent, ConfirmDialogComponent,
  AddToDiscoveryComponent, AddToFavoritesComponent, AddToPlaylistComponent, AddToPlaylistDialogComponent, CreatePlaylistComponent,
  SongDetailComponent, ChangePasswordComponent, SearchComponent, PlaylistItemComponent, PlaylistDurationComponent, MyAvatarComponent,
  DeletePlaylistComponent, GenericAvatarComponent, EditPlaylistComponent,CreateQuePlaylistComponent, PlaylistDetailComponent, MyDiscoveriesComponent,
  AccountListDetailComponent, FollowComponent, ArtistListDetailComponent, SongListDetailComponent, AlbumListDetailComponent,
  PlaylistListDetailComponent, FollowersOfUserComponent, FollowingOfUsersComponent, UserActivityComponent,
  MyMusicLibraryComponent, RecentLicensesComponent, AlbumDetailComponent, ArtistItemComponent, AlbumItemComponent, SongDetailPageComponent,
  ArtistDetailComponent, UserDetailComponent, UserListComponent, UsersFavoritesCountComponent, ResetPasswordComponent, DataTablesComponent, DataTableComponent,
  PlayerService, UserFavouriteDialog, AdvancedSearchComponent, AccountFollowerCountComponent, AccountFollowerCountDialog,
  AboutUsComponent, PrivacyPolicyComponent, SupportComponent, HomeSupportComponent, HomeDiscoverComponent, HomeGetpaidComponent,
  QuotaExceedComponent, SearchbarComponent, InlineEditComponent, PaymentInfoComponent, PaymentPendingComponent, MyPackageComponent,
  PaymentHistoryComponent, MyDownloadsComponent, LoaderComponent, PaymentDetailDialogComponent, DownloadComponent, PackageDetailComponent,
  DownloadDetailComponent, ProfileComponent, TrailPeriodComponent, PaypalErrorsComponent, SearchPageComponent, CartComponent, ViewCartComponent, CartItemComponent,
  CheckoutComponent, InviteFriendsComponent, InviteFriendsDialog, LogoutDialog, LogoutsDialog, SafePipe,RadioServerBusyDialog
} from './index';
// import { FlexDirective, LayoutDirective, EmailValidator, CustomHttp, EqualValidator, AuthenticationGuard } from '../directives';
import {
  EmailValidator, CustomHttp, EqualValidator, AuthenticationGuard, ScreenNameValidator, ReadMoreComponent,
  DefaultImage, MaskingDirective, ProfileCompletionGuard
} from '../directives';
import { ToastyModule } from 'ng2-toasty';
import { SecToMinPipe } from './sec-to-min.pipe';
import { HumanTime } from './human-time.pipe';
// import { TimeInSeconds } from './time-in-seconds.pipe';
import { NowPlayingPipe } from './now-playing.pipe';
import { ApiModule } from './api/api.module';
import { DragulaModule } from 'ng2-dragula/ng2-dragula';
import { ImageCropperModule } from 'ng2-img-cropper';
import { FileDropModule } from 'angular2-file-drop';
import { LoggingErrorHandler } from './app.exceptionhandler';
import { ScrollSpyModule, ScrollSpyService } from 'ng2-scrollspy';
import 'hammerjs';
import {
  SeekTrackComponent, PauseButtonComponent, StopButtonComponent, NextTrackComponent, PreviousTrackComponent, MuteTrackComponent,
  RepeatTrackComponent, MusicVolumeComponent, ClearPlaylistComponent, PlayerComponent, ViewQueueComponent, SongInfoAvatarComponent,
  SongInfoComponent, SongInfoDetailsComponent, PlayComponent, AddToQueueComponent
} from './index';
import { TooltipPipe } from './tooltip.pipe';
import { CustomFormsModule } from 'ng2-validation';
import { ChartsModule } from 'ng2-charts';
import { StatusPipe } from './status.pipe';
import { DomainComponent } from './shared/data-tables/domain/domain.component';
import { AddToCartComponent } from './shared/add-to-cart/add-to-cart.component';
import { SearchCountComponent } from './shared/search-count/search-count.component';
import { CartTotalPipe } from './cart/pipes/cart-total.pipe';
import { ShareButtonsModule } from 'ngx-sharebuttons';
import { GridViewPlaylistsComponent } from './playlists/grid-view-playlists/grid-view-playlists.component';
import { GenericAvatarGridviewComponent } from './shared/generic-avatar-gridview/generic-avatar-gridview.component';
import { MyReportsComponent } from './my-reports/my-reports.component';
import { DomainIconsComponent } from './shared/data-tables/domain-icons/domain-icons.component';
import { SongItemForArtistComponent } from './songs/song-item-for-artist/song-item-for-artist.component';
import { SongitemGridviewForArtistComponent } from './songs/songitem-gridview-for-artist/songitem-gridview-for-artist.component';
import { GridviewSongsComponent } from './songs/gridview-songs/gridview-songs.component';
import { AlbumviewSongsComponent } from './songs/albumview-songs/albumview-songs.component';
import { SongInfoNexttrackComponent } from './player/song-info/song-info-nexttrack/song-info-nexttrack.component';
import { SongInfoAvatarNextSongComponent } from './player/song-info/song-info-avatar-next-song/song-info-avatar-next-song.component';
import { GenericAvatarPlaylistsComponent } from './shared/generic-avatar-playlists/generic-avatar-playlists.component';
import { BlockUIModule } from 'ng-block-ui';
import { AllArtistComponent } from './artists/all-artist/all-artist.component';
import { QuillEditorModule } from 'ngx-quill-editor';
// http factory for import
// import {DataTableModule} from "angular2-datatable";
import { GenericAvatarFullImageComponent } from '../../src/app/player/song-info/song-info.component';
// import { RemoveFromQueComponent } from './songs/remove-from-que/remove-from-que.component';
import { ClickOutsideModule } from 'ng2-click-outside';
import { SongsSearchOnCreditsComponent } from './songs/songs-search-on-credits/songs-search-on-credits.component';
import { ForwardPlayComponent } from './player/forward-play/forward-play.component';
import { BackwardPlayComponent } from './player/backward-play/backward-play.component';
import { SurveyComponent } from './survey/survey.component';
import { SurveyService } from './survey.service';

export function httpFactory(backend: XHRBackend, defaultOptions: RequestOptions, router: Router) {
  return new CustomHttp(backend, defaultOptions, router);
}
@NgModule({
  declarations: [
    AppComponent,
    SafePipe,
    HomeComponent,
    LoginComponent,
    SongsComponent,
    AlbumsComponent,
    WelcomDialogComponent,
    ArtistsComponent,
    PlaylistsComponent,
    DashboardComponent,
    Four04Component,
    SignupComponent,
    LifestyleComponent,
    DemographicComponent,
    NotificationComponent,
    BillingComponent,
    SignupStepsComponent,
    PasswordStrengthComponent,
    EmailValidator,
    ForgotScreennameComponent,
    RequestPasswordResetComponent,
    UploadPictureDialog,
    EditScreenNameDialog,
    SongItemComponent,
    SongDurationComponent,
    AddToDiscoveryComponent,
    AddToFavoritesComponent,
    AddToPlaylistComponent,
    SecToMinPipe,
    AddToPlaylistDialogComponent,
    CreatePlaylistComponent,
    SongDetailComponent,
    ChangePasswordComponent,
    EqualValidator,
    SearchComponent,
    PlaylistItemComponent,
    PlaylistDurationComponent,
    DeletePlaylistComponent,
    GenericAvatarComponent,
    EditPlaylistComponent,
    CreateQuePlaylistComponent,
    PlaylistDetailComponent,
    MyDiscoveriesComponent,
    PlayButtonComponent,
    AccountListDetailComponent,
    FollowComponent,
    ArtistListDetailComponent,
    SongListDetailComponent,
    AlbumListDetailComponent,
    PlaylistListDetailComponent,

    MyMusicLibraryComponent,
    UserActivityComponent,
    FollowingOfUsersComponent,
    FollowersOfUserComponent,
    RecentLicensesComponent,
    ArtistDetailComponent,
    AlbumDetailComponent,
    ArtistItemComponent,
    AlbumItemComponent,
    SongDetailPageComponent,
    UserDetailComponent,
    UserListComponent,
    UsersFavoritesCountComponent,
    ResetPasswordComponent,
    PlayerComponent,
    SeekTrackComponent,
    PauseButtonComponent,
    StopButtonComponent,
    NextTrackComponent,
    PreviousTrackComponent,
    MuteTrackComponent,
    RepeatTrackComponent,
    MusicVolumeComponent,
    ClearPlaylistComponent,
    PlayComponent,
    ViewQueueComponent,
    AddToQueueComponent,
    // RemoveFromQueComponent,
    SongInfoComponent,
    SongInfoAvatarComponent,
    SongInfoDetailsComponent,
    HumanTime,
    // TimeInSeconds,
    UserFavouriteDialog,
    TooltipPipe,
    AdvancedSearchComponent,
    AccountFollowerCountComponent,
    AccountFollowerCountDialog,
    LoaderComponent,
    AboutUsComponent,
    PrivacyPolicyComponent,
    SupportComponent,
    HomeDiscoverComponent,
    HomeSupportComponent,
    HomeGetpaidComponent,
    DeleteFromPlaylistComponent,
    ConfirmDialogComponent,
    ScreenNameValidator,
    ReadMoreComponent,
    MyAvatarComponent,
    NowPlayingPipe,
    QuotaExceedComponent,
    SearchbarComponent,
    InlineEditComponent,
    DefaultImage,
    DataTablesComponent,
    DataTableComponent,
    MaskingDirective,
    PaymentInfoComponent,
    PaymentPendingComponent,
    MyDownloadsComponent,
    PaymentHistoryComponent,
    MyPackageComponent,
    PaymentDetailDialogComponent,
    StatusPipe,
    PackageDetailComponent,
    DownloadComponent,
    DownloadDetailComponent,
    ProfileComponent,
    TrailPeriodComponent,
    PaypalErrorsComponent,
    DomainComponent,
    SearchPageComponent,
    CartComponent,
    AddToCartComponent,
    SearchCountComponent,
    ViewCartComponent,
    CartItemComponent,
    CartTotalPipe,
    CheckoutComponent,
    InviteFriendsComponent,
    InviteFriendsDialog,
    LogoutDialog,
    LogoutsDialog,
    GridViewPlaylistsComponent,
    GenericAvatarGridviewComponent,
    MyReportsComponent,
    DomainIconsComponent,
    SongItemForArtistComponent,
    SongitemGridviewForArtistComponent,
    GridviewSongsComponent,
    AlbumviewSongsComponent,
    SongInfoNexttrackComponent,
    SongInfoAvatarNextSongComponent,
    GenericAvatarPlaylistsComponent,
    AllArtistComponent,
    GenericAvatarFullImageComponent,
    RadioServerBusyDialog,
    SongsSearchOnCreditsComponent,
    ForwardPlayComponent,
    BackwardPlayComponent,
    SurveyComponent,

  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    ReactiveFormsModule,
    DatePickerModule,
    MaterialModule.forRoot(),
    FlexLayoutModule,
    RouterModule.forRoot(routes),
    ToastyModule.forRoot(),
    ApiModule,
    ScrollSpyModule.forRoot(),
    ImageCropperModule,
    DndModule.forRoot(),
    FileDropModule,
    CustomFormsModule,
    ChartsModule, Ng2TweetModule,
    ShareButtonsModule.forRoot(),
    BlockUIModule,
    QuillEditorModule,
    ClickOutsideModule,
    // DataTableModule
    MomentModule

  ],
  providers: [
    PlayerService,
    AuthenticationGuard,
    SurveyService,
    ScrollSpyService,
    {
      provide: CustomHttp,
      useFactory: httpFactory,
      deps: [XHRBackend, RequestOptions, Router]
    },
    {
      provide: ErrorHandler,
      useClass: LoggingErrorHandler
    },
    ProfileCompletionGuard,
    SafePipe
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    UploadPictureDialog,
    EditScreenNameDialog,
    AddToPlaylistDialogComponent,
    CreatePlaylistComponent,
    SongDetailComponent,
    ChangePasswordComponent,
    EditPlaylistComponent,
    CreateQuePlaylistComponent,
    UserFavouriteDialog,
    AccountFollowerCountDialog,
    ConfirmDialogComponent,
    QuotaExceedComponent,
    PaymentPendingComponent,
    PaymentDetailDialogComponent,
    DownloadDetailComponent,
    TrailPeriodComponent,
    PaypalErrorsComponent,
    InviteFriendsDialog,
    LogoutDialog,
    LogoutsDialog,
    WelcomDialogComponent,
    GenericAvatarFullImageComponent,
    RadioServerBusyDialog,
  ]
})

export class AppModule {
}




// WEBPACK FOOTER //
// ./src/app/app.module.ts